import React, { Component } from 'react'
import shared from '../../../shared'
var moment = require("moment-timezone");

export default class IterationVol extends Component {
    render() {
        const itr = this.props.iten
        const elements = itr.map((iten, i) => {
            return (
              <div key={i}>
                {i !=0 && <>
                <hr className="m-2" />
                <center className="mb-1">{shared.diffTimes(itr[i-1].atime,iten.dtime)} layover</center>
                {iten.is_self_transfer && <center className="mb-1">Self-transfer</center>}
                {<center><a href="/hebergement">Hotel</a></center>}
                <hr className="m-2" />
                </>
                }
                <div className="plan__vol d-flex align-items-center">
                  <div className="col-sm-2 d-flex flex-column">
                    <img
                      className="d-flex"
                      src={`https://daisycon.io/images/airline/?width=500&height=150&color=f7f7f7&iata=${iten.airline.iata_code}`}
                      alt=""
                    />
                  </div>
      
                  <div className="plan__volInfos">
                    <h4 className="plan__volName det-colb-gr">
                      {iten.operating_airline.name} (Vol n°{iten.flight_no})
                    </h4>
                    {/* <h6 className="opacity__items det-colb-sm">duree de vol</h6> */}
                  </div>
                </div>
      
                <div className="plan__volDetails d-flex align-items-center mb-1 mt-1 mt-md-3">
                  <img
                    className="ml-3 mr-3 plan__timeline__bl"
                    src="/imgs/vols/da.svg"
                    alt=""
                  />
                  <div className="plan__departArv__cont">
                    <div className="plan__departArv ">
                      <div className="plan__depart mb-3 d-flex">
                        <div className="plan__departArv__time mr-4">
                          <h4 className="plan__volPlaces font-weight-bold det-colb-gr">
                            {moment.unix(iten.dtime).tz("GMT+0").format("HH:mm")}
                          </h4>
                          <h6 className="det-colb-sm opacity__tx">
                            {shared.unixToNormal(iten.dtime,true,false)}
                          </h6>
                        </div>
                        <div className="plan__departArv__place ml-4">
                          <h4 className="plan__volPlaces font-weight-bold det-colb-gr">
                            {iten.src_name}
                          </h4>
                          <p className="det-colb-sm opacity__tx">
                            {iten.src_station}
                          </p>
                        </div>
                      </div>
      
                          <p className="d-flex tx-sm">
                          {shared.diffTimes(iten.atime,iten.dtime)}
                          </p>
      
                      <div className="plan__arv d-flex">
                        <div className="plan__departArv__time mr-4">
                          <h4 className="plan__volPlaces font-weight-bold det-colb-gr">
                            {moment.unix(iten.atime).tz("GMT+0").format("HH:mm")}
                          </h4>
                          <h6 className="det-colb-sm opacity__tx">
                          {shared.unixToNormal(iten.atime,true,false)}
                          </h6>
                        </div>
                        <div className="plan__departArv__place ml-4">
                          <h4 className="plan__volPlaces det-colb-gr font-weight-bold">
                            {iten.dst_name}
                          </h4>
                          <p className=" det-colb-sm opacity__tx">
                            {iten.dst_station}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          });
        return (
            <div>
                {elements}
            </div>
        )
    }
}
